import Claim from "../../../apis/Claim";

/**
 * Get all Jobs
 * 
 * @param {*} filter : Object of key/values
 * @returns Promise of Claims
 */
 export const queryClaimsPromise = (store, filter) => {
  let queryParts = [];
  for (var p in filter) {
    if (Object.prototype.hasOwnProperty.call(filter, p)) {
      queryParts.push(encodeURIComponent(p) + "=" + encodeURIComponent(filter[p]));
    }
  }
  const params = queryParts.join('&');

  return Claim.all(params);
}


/**
 * Fetch an Job
 * 
 * @param {*} id : Job ID
 * @returns Job
 */
export const getClaimsPromise = (store, id) => {
  return Claim.fetch(id);
}
